import { useStores } from 'app/store'
import { Button, ButtonProps } from '../primitive/Button'
import { isWeb } from '@mythical/ui'
import { useRouter } from 'solito/router'
import { useAuthSessionLogin } from 'app/hooks/use-auth-session-login'
import { IconLock } from '../primitive/Icon'
import { useCurrentPath } from 'app/hooks/use-current-path'

interface ContentLockButtonProps extends ButtonProps {
  loggedOutLabel?: string
  upgradeLabel?: string
}

export const ContentLockButton = ({
  loggedOutLabel = 'Join to watch',
  upgradeLabel = 'Upgrade to Watch',
  ...buttonProps
}: ContentLockButtonProps) => {
  const { userStore, upgradeModalState } = useStores()
  const router = useRouter()
  const { startLogin } = useAuthSessionLogin()
  const { path: currentPath } = useCurrentPath()

  const loggedIn = !!userStore?.user?.id
  const canMemberfulLink = userStore?.canMemberfulLink ?? false

  const handleJoin = () => {
    if (canMemberfulLink || isWeb) {
      router.push('/perks')
    } else {
      startLogin()
    }
  }

  const handleUpgrade = () => {
    upgradeModalState.setUpgradeReturnPath(currentPath || '/')

    // Show upsell modal (safe to show in supported regions)
    upgradeModalState.openUpsellModal()
  }

  const effectiveLoggedOutLabel = canMemberfulLink
    ? loggedOutLabel
    : 'Log in to watch'

  if (loggedIn && !canMemberfulLink) {
    return null
  }

  return (
    <Button
      icon={<IconLock />}
      scaleSpace={0.4}
      scaleIcon={1.2}
      {...buttonProps}
      onPress={loggedIn ? handleUpgrade : handleJoin}
    >
      {loggedIn ? upgradeLabel : effectiveLoggedOutLabel}
    </Button>
  )
}
